import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityFeatures = () => {
  const securityFeatures = [
    {
      icon: 'Lock',
      title: 'SSL Encryptie',
      description: 'Alle gegevens worden veilig versleuteld verzonden'
    },
    {
      icon: 'Shield',
      title: 'GDPR Compliant',
      description: 'Volledige naleving van Europese privacywetgeving'
    },
    {
      icon: 'Eye',
      title: 'Privacy Bescherming',
      description: 'Uw bedrijfsgegevens blijven altijd privé'
    }
  ];

  return (
    <div className="bg-muted/30 rounded-lg border border-border p-4">
      <div className="flex items-center space-x-2 mb-3">
        <Icon name="ShieldCheck" size={16} color="var(--color-success)" />
        <h3 className="text-sm font-heading font-medium text-foreground">
          Beveiligingsgaranties
        </h3>
      </div>
      <div className="space-y-3">
        {securityFeatures?.map((feature, index) => (
          <div key={index} className="flex items-start space-x-2">
            <Icon name={feature?.icon} size={14} color="var(--color-success)" className="mt-0.5" />
            <div>
              <p className="text-xs font-body font-medium text-foreground">
                {feature?.title}
              </p>
              <p className="text-xs font-body text-muted-foreground">
                {feature?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-4 pt-3 border-t border-border">
        <div className="flex items-center justify-between text-xs font-caption text-muted-foreground">
          <span>Laatste update: 27 aug 2025</span>
          <div className="flex items-center space-x-1">
            <div className="w-2 h-2 bg-success rounded-full"></div>
            <span>Actief</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecurityFeatures;